<template>
    <div class="ledger-file">
        <el-upload
            :action="uploadURL"
            :headers="headers"
            :multiple="true"
            :data="data"
            :accept="accept"
            :file-list="fileList"
            name="upfile"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
            :limit="200"
            :on-exceed="handleExceed"
            list-type="picture-card"
            ref="upload"
            drag
            :class="{'readonly': readonly}"
        >
<!--            <i slot="default" class="el-icon-plus upload-add"></i>-->
            <template v-slot:default>
                <div class="prepare-upload">
                    <i class="icon el-icon-upload"></i>
                    <p class="text">将文件拖到此处，或<em>点击上传</em></p>
                </div>
            </template>

            <div slot="file" slot-scope="{file}" class="file-item" v-if="file.response">
                <!-- 图像 -->
                <img v-if="file.response && file.response.type===12"
                     class="el-upload-list__item-thumbnail"
                     :src="file.url" alt="thumbnail"
                >

                <!-- 文档 -->
                <a v-if="file.response && file.response.type===8" class="document">
                    <span class="res-document-excel"
                          v-if="file.response.extension==='.xls'||file.response.extension==='.xlsx'"></span>
                    <span class="res-document-pdf"
                          v-else-if="file.response.extension==='.pdf'"></span>
                    <span class="res-document-ppt"
                          v-else-if="file.response.extension==='.ppt'||file.response.extension==='.pptx'"></span>
                    <span class="res-document-txt"
                          v-else-if="file.response.extension==='.txt'"></span>
                    <span class="res-document-word"
                          v-else-if="file.response.extension==='.doc'||file.response.extension==='.docx'"></span>
                    <span class="res-document-undefined"
                          v-else></span>
                </a>

                <h3>{{file.response.name}}</h3>
                <h4>{{formatSize(file.response.length)}}</h4>

                <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                        class="el-upload-list__item-delete"
                        @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span>
                    <span
                        v-if="!readonly"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
              </span>
            </div>
        </el-upload>

        <a :href="downloadURL" id="download"></a>

        <div id="preview-image" v-viewer="{movable: false}" style="display: none">
            <img v-for="item in imageList" :src="`${item.response && item.response.previewUrl}?access_token=${token}`"
                 :key="item.id">
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import {ACCEPT_CONFIG} from '@/config/constant';

    const MAX_SIZE = 10;  // 文件最大限制，单位M

    export default {
        props: {
            initFiles: Array,
            readonly: {
                default: false
            }
        },
        components: {},
        data() {
            return {
                uploadURL: api.attachmentUploaderURL,
                headers: {
                    Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                },
                data: {
                    culture: this.$i18n.locale,
                    'ui-culture': this.$i18n.locale
                },
                fileList: [],
                downloadURL: '',
                docSrc: ''
            }
        },
        created() {
        },
        computed: {
            accept() {
                let doc = ACCEPT_CONFIG.document.filter(item => !['.tif', '.tiff'].includes(item));
                return [...ACCEPT_CONFIG.image, ...doc].join()
            },
            token() {
                return Ticket.get().access_token
            },
            imageList() {
                let arr = this.fileList.filter(item => item.response && item.response.type === 12)
                return arr
            }
        },
        methods: {
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < MAX_SIZE;
                if (!isLt2M) {
                    this.$message.error(`上传附件大小不能超过 ${MAX_SIZE} MB!`);
                    return false
                }
            },

            onSuccess(response, file, fileList) {
                this.fileList = fileList;
                this.$emit('file-change', this.fileList)
            },

            onError(err) {
                this.$message.error(err)
            },

            handleRemove(file) {
                let f = file.response;
                let index = this.fileList.findIndex(item => item.response.id === f.id);
                this.fileList.splice(index, 1);
                this.$emit('file-change', this.fileList)
                //this.$refs.upload.handleRemove()
            },
            handlePreview(file) {
                let f = file.response;
                // 图片
                if (f.type === 12) {
                    let index = this.imageList.findIndex(item => item.response.id === f.id);
                    let viewer = $('#preview-image')[0].$viewer;
                    viewer.view(index)
                } else if (f.type === 8) {
                    //this.docSrc = `${f.previewUrl}?access_token=${this.token}`;
                    console.log(`${f.previewUrl}?access_token=${this.token}`)
                    window.open(`${f.previewUrl}?access_token=${this.token}`)
                }
            },
            handleDownload(file) {
                let f = file.response;
                this.downloadURL = `${f.downloadUrl}?access_token=${this.token}`;
                this.$nextTick(() => {
                    $('#download')[0].click()
                });
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 200 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },

            formatSize(size, pointLength, units) {
                var unit;
                units = units || ['B', 'K', 'M', 'G', 'TB'];
                while ((unit = units.shift()) && size > 1024) {
                    size = size / 1024;
                }
                return (unit === 'B' ? size : size.toFixed(pointLength || 2)) + unit;
            }
        },
        watch: {
            initFiles: {
                handler: function(files) {
                    let rst = [];
                    files.forEach(item => {
                        rst.push({
                            name: item.name,
                            percentage: 100,
                            size: ~~item.length,
                            status: 'success',
                            url: `${item.previewUrl}?access_token=${this.token}`,
                            response: item
                        })
                    });


                    this.fileList = rst;
                },
                immediate: true
            }
        },
    }
</script>

<style lang="scss">
    @import '../../../style/const.scss';

    .ledger-file {
        position: relative;

        .readonly {
            >div.el-upload--picture-card {
                display: none;
            }
        }

        .el-upload-list__item, .el-upload--picture-card {
            width: 130px;
            height: 130px;
        }

        .el-upload-list__item-thumbnail {
            width: 100%;
            height: 90px;
            object-fit: cover;
        }

        .file-item {
            width: 100%;
            height: 100%;
            text-align: center;

            > h3 {
                padding: 0 5px;
                font-size: 12px;
                line-height: 1.4;
                @include no-wrap
            }

            > h4 {
                font-size: 12px;
                line-height: 1.4;
                color: #999;
            }
        }

        .document {
            display: block;
            padding: 10px;
            height: 90px;

            > span {
                display: block;
                height: 100%;
            }

            .res-document-excel {
                background: url(../../../assets/images/document/excel.png) center no-repeat;
                background-size: contain;
            }

            .res-document-pdf {
                background: url(../../../assets/images/document/pdf.png) center no-repeat;
                background-size: contain;
            }

            .res-document-ppt {
                background: url(../../../assets/images/document/ppt.png) center no-repeat;
                background-size: contain;
            }

            .res-document-txt {
                background: url(../../../assets/images/document/txt.png) center no-repeat;
                background-size: contain;
            }

            .res-document-undefined {
                background: url(../../../assets/images/document/undefined.png) center no-repeat;
                background-size: contain;
            }

            .res-document-word {
                background: url(../../../assets/images/document/word.png) center no-repeat;
                background-size: contain;
            }
        }


        // 拖拽上传
        .el-upload-dragger {
            width: 130px;
            height: 130px;
        }
        .prepare-upload {
            padding: 0 12px;
            line-height: 1.8;
            .icon {
                font-size: 48px;
                margin: 12px 0 5px 0;
                color: #c0c4cc;
            }
            .text {
                font-size: 12px;
                color: #666;
                em {
                    color: #409eff;
                    font-style: normal;
                }
            }
        }
        // 改变上传框的位置
        ul.el-upload-list--picture-card {
            /*display: block;*/
            .el-upload-list__item:first-child {
                /*margin-left: 138px;*/
                /*transition-property: opacity, transform;*/
                /*transition-duration: .5s;*/
            }
        }
        div.el-upload--picture-card {
            /*position: absolute;*/
            /*top: 0;*/
            /*left: 0;*/
            border: none;
        }
    }
</style>
